<template>
  <div class="flex flex-wrap gap-4" :class="direction === 'horizontal' ? 'flex-row' : 'flex-col'">
    <div v-for="(option, index) in props.options" class="flex items-center" :class="buttonClass">
      <div>
        <label v-if="labelLocation === 'left'" :for="props.name + index" class="font-bold ml-2">{{ getOptionLabel(option) }}</label>
        <RadioButton v-model="value" :inputId="props.name + index" :name="props.name" :value="option" :disabled="disabled" @change="handleChange" />
        <label v-if="labelLocation === 'right'" :for="props.name + index" class="font-bold ml-2">{{ getOptionLabel(option) }}</label>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  name: string;
  options: any[];
  optionLabel?: string;
  buttonClass?: string;
  onChange?: Function;
  labelLocation?: "left" | "right";
  direction?: "horizontal" | "vertical";
  disabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  buttonClass: "",
  labelLocation: "right",
  direction: "horizontal",
  disabled: false,
});

const getOptionLabel = (option: any): string => {
  return props.optionLabel ? option[props.optionLabel] : option;
};

const handleChange = (): void => {
  if (props.onChange) props.onChange();
};

const value = defineModel<string>({ required: true });
</script>
